import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full flex flex-grow flex-col", _ctx.className]),
    shallowRef: "wrapper"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col flex-grow", _ctx.wrapperClasses])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}